import { HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DopplerService {
    constructor(http) {
        this.http = http;
        this.API_URL = 'https://restapi.fromdoppler.com/accounts';
        this.ACCOUNT_NAME = 'marketing@vittal.com.ar';
        this.LIST_ID = '29076950';
        this.API_KEY = '38E272DFE673B985E7AC24A4A681B663';
    }
    submitForm(formData) {
        const headers = new HttpHeaders({
            'Authorization': `token ${this.API_KEY}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Doppler-Subscriber-Origin': 'Landing DEA'
        });
        const subscriber = {
            email: formData.email,
            fields: [
                {
                    name: 'FIRSTNAME',
                    value: formData.nombre,
                    type: 'string'
                },
                {
                    name: 'LASTNAME',
                    value: formData.apellido,
                    type: 'string'
                },
                {
                    name: 'Empresa',
                    value: formData.empresa || '',
                    type: 'string'
                },
                {
                    name: 'Celular',
                    value: formData.telefono,
                    type: 'phone'
                },
                {
                    name: 'Localidad',
                    value: formData.localidad || '',
                    type: 'string'
                }
            ],
            status: 'active'
        };
        return this.http.post(`${this.API_URL}/${this.ACCOUNT_NAME}/lists/${this.LIST_ID}/subscribers`, subscriber, { headers });
    }
}
DopplerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DopplerService_Factory() { return new DopplerService(i0.ɵɵinject(i1.HttpClient)); }, token: DopplerService, providedIn: "root" });
